import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Image from '../../../base/Image/Image.js';
import { IImageProps } from '../../../base/Image/models/IImageProps.js';
import { FUND_MANAGER_CATEGORY_KEY, FUND_MANAGER_COMPONENT_KEY } from '../FundManager.meta.js';

export const imageError = (imageElement: HTMLImageElement) => {
	imageElement.src = 'data:image/svg+xml,<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg"/>';
	imageElement.style.display = 'none';
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const FundManagerImage = (props: IImageProps) => {
	return <Image {...props} onError={(e: any) => imageError(e.target as any)} />;
};

export default InjectedStyledComponent(FundManagerImage, FUND_MANAGER_CATEGORY_KEY, FUND_MANAGER_COMPONENT_KEY, [
	'fundManagerImage',
]);
